import styled from '@emotion/styled'
import React from 'react'
import DialogContainer from '~/components/DialogContainer'
import DialogContent from '~/components/DialogContent'
import DialogTitle from '~/components/DialogTitle'
import PrimaryButton from '~/components/PrimaryButton'
import SecondaryButton from '~/components/SecondaryButton'








const StyledDialogContainer = styled(DialogContainer)({
  width: 480
})

const ButtonGroup = styled('div')({
  marginTop: '24px',
  display: 'flex',
  justifyContent: 'flex-end'
})

const StyledTip = styled('p')({
  fontSize: 14,
  lineHeight: '20px',
  margin: 0,
  padding: '0 0 16px'
})

const StyledPrimaryButton = styled(PrimaryButton)({
  marginLeft: 16
})

const TaskFooterTeamAssigneeAddIntegrationDialog = (props) => {
  const {onClose, onConfirm, serviceName, teamName} = props

  return (
    React.createElement(StyledDialogContainer, null
      , React.createElement(DialogTitle, null
        , serviceName, " integration for "   , teamName
      )
      , React.createElement(DialogContent, null
        , React.createElement('div', null
          , React.createElement(StyledTip, null, "You don't have "
               , serviceName, " configured for "   , teamName, ". Do you want to add it now?"
          )
          , React.createElement(ButtonGroup, null
            , React.createElement(SecondaryButton, { onClick: onClose, size: "medium",}, "Cancel"

            )
            , React.createElement(StyledPrimaryButton, { onClick: onConfirm, size: "medium",}, "Add it now"

            )
          )
        )
      )
    )
  )
}

export default TaskFooterTeamAssigneeAddIntegrationDialog
